import { RSAA } from "redux-api-middleware";
import config from "config";

export const updatePrescribersProfileList = (
  pageSize,
  page,
  sorted,
  filtered,
  resized,
  expanded
) => {
  
  // Convert filter value objects to plain strings
  let transformedFiltered = [];

  if (Array.isArray(filtered)) {
    transformedFiltered = filtered.map(filter => {
      if (Array.isArray(filter.value)) {
        return {
          id: filter.id,
          value: filter.value.map(v => (typeof v === "object" ? v.id : v)),
        };
      }
      return filter;
    });
  }

  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/contact-management/prescribers/profile/list`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pageSize, page, sorted, filtered: transformedFiltered }),
      types: [
        {
          type: "UPDATE_PRESCRIBERS_PROFILE_LIST_REQUEST",
          payload: {
            listState: { pageSize, page, sorted, filtered, resized, expanded },
          },
        },
        "UPDATE_PRESCRIBERS_PROFILE_LIST_SUCCESS",
        "UPDATE_PRESCRIBERS_PROFILE_LIST_FAILURE",
      ],
    },
  };
};
export const resetError = () => {
  return {
    type: "RESET_ERROR_MESSAGE_PRESCRIBERS_PROFILE_LIST",
  };
};
export const updatePrescribersProfileIndexOnList = (index) => {
  return {
    type: "UPDATE_PRESCRIBERS_PROFILE_INDEX_ON_LIST",
    indexOnList: index,
  };
};
